// extracted by mini-css-extract-plugin
module.exports = {"badges":"PublicCampaignHeaderUI__badges___34dqS","badge":"PublicCampaignHeaderUI__badge___3KY5j","participate":"PublicCampaignHeaderUI__participate___zB85d"};